const UPDATE_PASSWORD_BEGIN = 'account/EditPassword/UPDATE_PASSWORD_BEGIN';
const UPDATE_PASSWORD_SUCCESS = 'account/EditPassword/UPDATE_PASSWORD_SUCCESS';
const UPDATE_PASSWORD_FAILURE = 'account/EditPassword/UPDATE_PASSWORD_FAILURE';

export { UPDATE_PASSWORD_BEGIN, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAILURE };
